import React from "react";

export type SortIcon = "up_down_caret" | "caret_up" | "caret_dn";

export const sortDirectionIcons: Record<"neutral" | "asc" | "des", SortIcon> = {
  neutral: "up_down_caret",
  asc: "caret_up",
  des: "caret_dn",
};

export type SortDirection = "asc" | "des" | "neutral";

export type Alignment = "left" | "right" | "center" | "justify";

export const alignments: Record<
  "Left" | "Right" | "Center" | "Justify",
  Alignment
> = {
  Left: "left",
  Right: "right",
  Center: "center",
  Justify: "justify",
};

export type CheckState = "checked" | "half-checked" | "unchecked";

export type TableDataType = Record<any, any>;

export interface TableColumn<DataType extends TableDataType = any> {
  /**
   * Sets the cell's text alignment. Inherits the table alignment if not present
   */
  alignment?: Alignment;
  /**
   * Strategy for rendering table cells for that column. Receives `dataItem` as an argument
   */
  renderCell: (props: DataType) => React.ReactNode;
  /**
   * If true, renders the column as a check box
   */
  isCheckBox?: boolean;
  /**
   * If true, renders the column as an expansion toggle
   */
  isExpansionToggle?: boolean;
  /**
   * String, function, or React element used for the column heading
   */
  header:
    | string
    | (() => React.ReactNode)
    | React.ReactNode
    | React.ReactElement;
  /**
   * Sets the default order by which a sell is ordered. Neutral means sortable, null is not
   */
  sort?: SortDirection | null;
  /**
   * String-value width (in a style tag) of the column
   */
  width?: string;
  /**
   * If true, the column will not be shown in the responsive view
   */
  hideOnResponsive?: boolean;
  /**
   * If true, the column will not be shown in the responsive preview
   */
  hideOnResponsivePreview?: boolean;
}

export type DataKey = string | number;

export const checkState: Record<
  "CHECKED" | "HALFCHECKED" | "UNCHECKED",
  CheckState
> = {
  CHECKED: "checked",
  HALFCHECKED: "half-checked",
  UNCHECKED: "unchecked",
};

export const breakpoints: Record<446 | 600 | 768 | 912 | 1238, number> = {
  446: 446,
  600: 600,
  768: 768,
  912: 912,
  1238: 1238,
};

export type MobileVariant = "tableScrollWindow" | "cards";

export interface MobileCardComponentProps<DataType = TableDataType> {
  row: DataType;
  columns: TableColumn<any>[];
}
